.MorsePoster {
    width: 440px;
}
.MorsePoster.ScaledDown {
    width: 200px;
}
